import React from "react";
import "../styles/About.css";

const About: React.FC = () => {
  return (
    <div className="about-container">
      <h1 className="about-title">About Us</h1>
      <p className="about-text">
Coming Soon...
      </p>
    </div>
  );
};

export default About;
